/**
 * Frontend configuration constants.
 * All default values should be defined here, not inline.
 */

// Vite dev server port (frontend serves through this, proxies API)
export const DEFAULT_SERVER_PORT = 1333;

// API prefix
export const API_PREFIX = "/api";

// Protocol defaults
export const DEFAULT_HTTP_PROTOCOL = "http";
export const DEFAULT_WS_PROTOCOL = "ws";

// Player appearance defaults
export const DEFAULT_PLAYER_COLOR = "#a855f7"; // Purple - default for registered users
export const GUEST_PLAYER_COLOR = "#6b7280"; // Gray - for guest/anonymous users
export const DEFAULT_PLAYER_EMOJI = "👤"; // Default emoji for registered users without custom emoji
export const GUEST_PLAYER_EMOJI = "🕵️"; // Anonymous/incognito emoji for guest users
